module.exports = __webpack_public_path__ + "static/media/todo.3d3eae0f.png";